import http from '@/utils/http'

const fetch = () => http()
  .get(`/bank`)

const fetchKyc = () => http()
  .get(`/kyc`)

const save = ({ data }) => http()
  .post(`/banks`, data)

const wallet = () => http()
  .get(`/balances`)

const transfer = ({ amount, currency, reference }) => http()
  .post(`/payouts`, {
    currency,
    amount,
    reference
  })

export default {
  fetch,
  fetchKyc,
  save,
  wallet,
  transfer
}



// WEBPACK FOOTER //
// ./src/api/bank.js